import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import RadioInput from "./RadioInput";
import MonthInput from "./MonthInput";
import YearInput from "./YearInput";
import WizardFooter from "./WizardFooter";
export const fields = [
  "convicted_of_felony",
  "convictionMonth",
  "convictionYear",
  "releaseMonth",
  "releaseYear",
];

const validate = (values, props) => {
  const errors = {};
  if (values.convicted_of_felony) {
    if (values.convicted_of_felony === "yes") {
      if (!values.convictionMonth) {
        errors.convictionMonth = props.allText.shared.required;
      }
      if (!values.convictionYear) {
        errors.convictionYear = props.allText.shared.required;
      }
      if (!values.releaseMonth) {
        errors.releaseMonth = props.allText.shared.required;
      }
      if (!values.releaseYear) {
        errors.releaseYear = props.allText.shared.required;
      }
    }
  } else {
    errors.convicted_of_felony = props.allText.shared.required;
  }
  return errors;
};

export const WizardFormSection06 = props => {
  const {
    allText,
    fields: {
      convicted_of_felony,
      convictionMonth,
      convictionYear,
      releaseMonth,
      releaseYear,
    },
    handleSubmit,
    previousPage,
  } = props;
  const text = { ...allText.shared, ...allText.section06 };
  const progress = 5;
  return (
    <form onSubmit={handleSubmit} className="form-horizontal">
      <div className="wizard-page-content">
        <div className="page-title-container">
          <span className="page-title underline">{text.title}</span>
          <span className="wizard-text question-text">{text.subtitle}</span>
        </div>
        <div>
          <div className="primary-question">{text.primaryQuestion}</div>
          <RadioInput text={text} field={convicted_of_felony} />
        </div>
        <div className="separator" />
        {convicted_of_felony.value === "yes" && (
          <div className="row">
            <div className="col-12 col-sm-6">
              <div className="wizard-text">{text.question01}</div>
              <div className="row">
                <div className="col-6">
                  <MonthInput text={text} field={convictionMonth} />
                </div>
                <div className="col-6">
                  <YearInput
                    text={text}
                    field={convictionYear}
                    monthSelected={releaseMonth}
                    shouldCheckMonth={false}
                  />
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6">
              <div className="wizard-text">{text.question02}</div>
              <div className="row">
                <div className="col-6">
                  <MonthInput text={text} field={releaseMonth} />
                </div>
                <div className="col-6">
                  <YearInput
                    text={text}
                    field={releaseYear}
                    monthSelected={releaseMonth}
                    shouldCheckMonth={false}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <WizardFooter
        text={text}
        previousPage={previousPage}
        progress={progress}
      />
    </form>
  );
};

WizardFormSection06.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSection06);



// WEBPACK FOOTER //
// ./src/components/WizardFormSection06.js